// extracted by mini-css-extract-plugin
export default {"sidebar":"ConfigurationSidebar_sidebar__carLW","sidebar__wrapper":"ConfigurationSidebar_sidebar__wrapper__V6uX7","sidebar__support":"ConfigurationSidebar_sidebar__support__nYS7W"};